import React, { Fragment } from "react";
import strings from "translate/language";
import { handleDetailResponse } from "utils/utils";

const PropertyList = (props) => {
  const {
    senderID = "",
    propertyList = [],
    handleClickProperty = () => {},
    loadMore = () => {},
    onChangeInput = () => {},
    inputValue = "",
    listLabel = "",
    isLoading = false,
    isListLabel = false,
    isSearchInput = false,
  } = props;
  return (
    <Fragment>
      <div className="card">
        <div className="chat-body">
          <div className="chat-box">
            {/* <!-- Chat left side Start--> */}
            <div className="chat-left-aside">
              <div className="people-list" id="people-list">
                {/* {isSearchInput && (
                  <div className="search">
                    <form className="theme-form">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="search"
                          value={inputValue}
                          onChange={(e) => onChangeInput(e.target.value)}
                        />
                        <i className="fa fa-search"></i>
                      </div>
                    </form>
                  </div>
                )} */}
                {isListLabel && (
                  <div className="name f-w-700 mb-3">{listLabel}</div>
                )}
                <ul className="list">
                  {propertyList.length > 0 ? (
                    propertyList.map((property, index) =>
                       (
                        <li key={index} className="clearfix">
                          <img
                            className="rounded-circle user-image"
                            src={
                              (handleDetailResponse(property.property_document).document &&
                              handleDetailResponse(property.property_document).document_type === "image")
                                ? `${property.base_url}${handleDetailResponse(property.property_document).document}`
                                : "/assets/images/user_old.png"
                            }
                            alt={property.property_title}
                          />
                          {/* <div className="status-circle away online offline"></div> */}
                          <div
                            onClick={() => handleClickProperty(property._id)}
                            className="about breadcrumb-item"
                          >
                            <div className="name">{property.property_title}</div>
                            <div className="status">{property.city}</div>
                          </div>
                        </li>
                      )
                    )
                  ) : (
                    <li className="clearfix">{strings.dataNotFound}</li>
                  )}
                  {propertyList.length > 9 && (
                    <li className="load-more">
                      <button
                        className="btn btn-color ml-5"
                        type="button"
                        onClick={loadMore}
                      >
                        {isLoading ? "Loading..." : "Load More"}
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            {/* <!-- Chat left side Ends--> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PropertyList;
